import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { PartnerConnectTotalStakeStepperControl } from "../controls/partner-connect-total-stake-stepper-control";

export class PartnerConnectTotalStakeStepperControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        if (layer.getFlexiButton("stake_up") &&
            layer.getFlexiButton("stake_down")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        return [new PartnerConnectTotalStakeStepperControl(layer.getFlexiButton("stake_down"), layer.getFlexiButton("stake_up"), layer.getFlexiText("stake_value"))];
    }
}
